import React from 'react';

function ConfirmModal({ isOpen, onClose, onConfirm, title, message }) {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-coal rounded-lg p-6 max-w-md w-full mx-4"
                 style={{
                     boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                     backgroundImage: `url('/img/console-bg-darker.png')`
                 }}>
                <div className="bg-maroon px-4 py-3 -mx-6 -mt-6 mb-4 rounded-t-lg">
                    <h3 className="text-white font-['Jersey_10'] uppercase text-[18px] tracking-[1px]"
                        style={{
                            textShadow: '-1px -1px 0 rgba(0, 0, 0, 0.5), 1px -1px 0 rgba(0, 0, 0, 0.5), -1px 1px 0 rgba(0, 0, 0, 0.5), 1px 1px 0 rgba(0, 0, 0, 0.5)'
                        }}>
                        {title}
                    </h3>
                </div>

                <div className="bg-offwhite p-4 rounded mb-4">
                    <p className="text-gray-700">{message}</p>
                </div>

                <div className="flex gap-3 justify-end">
                    <button
                        onClick={onClose}
                        className="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 font-['Jersey_10'] uppercase text-[16px] tracking-[1px] transition-colors"
                        style={{
                            boxShadow: '0 2px 0 0 rgba(0, 0, 0, 0.3)'
                        }}
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onConfirm}
                        className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 font-['Jersey_10'] uppercase text-[16px] tracking-[1px] transition-colors"
                        style={{
                            boxShadow: '0 2px 0 0 rgba(0, 0, 0, 0.3)'
                        }}
                    >
                        Confirm
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ConfirmModal;